<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>

    <v-row class="mx-1 mt-3">
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
            background-color="#EDF2F7"
            v-model="ward.keyword"
            filled
            label="Nhập tên vùng miền"
            @input="debounceInput"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-container fluid>
      <v-row justify="center" align="center">

        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="regions.wards"
              class="elevation-1"
            :server-items-length="totalItemCount"
            :options.sync="pagination"
          >
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { GET_DATA_SEARCH_REGION } from "@/store/modules/regions";
import {mapGetters} from "vuex";
import {debounce} from "debounce";


export default {
    data() {
        return {
            totalItemCount: 10,
            pagination: {
                page: 1,
                rowsPerPage: 10,
                itemsPerPage: 10,
                totalItems: 0
            },
            page: "Quản lý vùng miền",
            breadcrumbs: [
                {
                    text: "Trang chủ",
                    disabled: true
                },
                {
                    text: "Quản lý vùng miền",
                    disabled: true,
                }
            ],
            ward : {
                keyword: ""
            },
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Phường/Xã', value: 'name' },
                { text: 'Quận/Huyện', value: 'district_name' },
                { text: 'Tỉnh/TP', value: 'province_name' },
                { text: 'Miền', value: 'area_name' }
            ],
        };
    },
    computed: {
        ...mapGetters({
        regions: "regions"
        }),
    },
    watch:{
        regions(val){
            this.totalItemCount = val.paginate.total
        },
        pagination: {
            handler() {
                this.debounceInput(this.ward.keyword, 'page');
            },
            deep: true
        },
    },
    async created() {
        await this.$store.dispatch(GET_DATA_SEARCH_REGION, this.getParams());
    },
    methods:{
        debounceInput: debounce(function (e, page = '') {
            this.ward.keyword = e;
            if(page != 'page' && this.pagination.page != 1){
                this.pagination.page = 1;
                return;
            }
            this.$store.dispatch(GET_DATA_SEARCH_REGION, this.getParams());
        }, 200),
        getParams(){
            return {
                keyword : this.ward.keyword,
                limit : this.pagination.itemsPerPage,
                page : this.pagination.page
            }
        }
    }
};
</script>
<style scoped lang="scss">
.width-input {
  max-width: 240px!important;
}
</style>